import { fetchClientApiStep } from '../clientApiStep.helpers';

/** Calls the AppointmentPicking step's `list` operation; returns the slots and the whole response. */
// eslint-disable-next-line import/prefer-default-export
export const fetchClientApiSlots = async ({
  api,
  body,
  submissionId,
  token,
}) => {
  const response = await fetchClientApiStep({
    api,
    body,
    submissionId,
    token,
    label: 'Slot lookup',
  });
  if (!Array.isArray(response.data))
    throw new Error('Slot lookup returned an unexpected response shape');
  return { slots: response.data, response };
};
